// FAQ.jsx

import { useState } from "react";
import "../../styles/garage/garage-main.css";

const faqs = [
    {
        question: "What does the garage management software include?",
        answer:
            "The platform brings your garage operations together in one place, including invoicing, financial tracking, work orders, staff management and other day-to-day management tools.",
    },
    {
        question: "Can I add multiple members of staff?",
        answer:
            "Yes. You can add your staff members to the system and manage their access and responsibilities from one central place.",
    },
    {
        question: "Can I track payments and expenses?",
        answer:
            "Yes. The finance tools help you keep track of income, expenses, outstanding payments and other important financial activity.",
    },
    {
        question: "Can I cancel my subscription?",
        answer:
            "Yes. You can manage your subscription according to the billing terms of your selected plan. Your account and data remain accessible according to the applicable service terms.",
    },
];

export default function FAQ() {
    const [open, setOpen] = useState(0);

    return (
        <section className="garage-faq" id="faq">
            <div className="faq-intro">

                <h2>
                    Questions?
                    <br />
                    <span>We've got answers.</span>
                </h2>

                <p>
                    Everything you need to know before getting your
                    garage set up.
                </p>
            </div>

            <div className="faq-list">
                {faqs.map((faq, index) => (
                    <div
                        className={`faq-item ${
                            open === index ? "open" : ""
                        }`}
                        key={faq.question}
                    >
                        <button
                            className="faq-question"
                            onClick={() =>
                                setOpen(open === index ? -1 : index)
                            }
                        >
                            <span>{faq.question}</span>
                            <span className="faq-icon">
                                {open === index ? "−" : "+"}
                            </span>
                        </button>

                        <div className="faq-answer">
                            <p>{faq.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}